export { default } from '@rsos/base-assets/icons/src/SVGLoader';
